import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"color":"#f50"} }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ant_icon = _resolveComponent("ant-icon")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "材料分类",
    size: "small",
    loading: _ctx.loading,
    style: {"overflow":"auto"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_input, {
        value: _ctx.keyword,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
        "allow-clear": "",
        style: {"margin-bottom":"8px"},
        placeholder: "请输入材料分类关键字"
      }, {
        prefix: _withCtx(() => [
          _createVNode(_component_ant_icon, { type: "SearchOutlined" })
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_a_tree, {
        "auto-expand-parent": _ctx.autoExpandParent,
        expandedKeys: _ctx.expandedKeys,
        selectedKeys: _ctx.selectedKeys,
        "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedKeys) = $event)),
        "tree-data": _ctx.treeRecords,
        fieldNames: { children: 'children', title: 'name', key: 'id' },
        onExpand: _ctx.onExpand,
        onSelect: _ctx.onSelect,
        style: _normalizeStyle({height:_ctx.height+'px','overflow':'auto'})
      }, {
        title: _withCtx(({ name, id }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(id === null ? { fontWeight: 'bold', fontSize: '15px' } : {})
          }, [
            (name.indexOf(_ctx.keyword) > -1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  _createElementVNode("span", null, _toDisplayString(name.substr(0, name.indexOf(_ctx.keyword))), 1),
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.keyword), 1),
                  _createElementVNode("span", null, _toDisplayString(name.substr(name.indexOf(_ctx.keyword) + _ctx.keyword.length)), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(name), 1))
          ], 4)
        ]),
        _: 1
      }, 8, ["auto-expand-parent", "expandedKeys", "selectedKeys", "tree-data", "onExpand", "onSelect", "style"])
    ]),
    _: 1
  }, 8, ["loading"]))
}